
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p374601101779828736',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

